<template>
  <b-modal
    :active="active"
    @close="$emit('close')"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    class="modal-layout"
  >
    <div class="modal-card" style="width: auto">
      <section class="modal-card-body">
        <h1>{{ title || $t('server.model.add_model') }}</h1>
        <div class="columns">
          <div class="column select-column">
            <div class="custom-select-label" :class="{ search: isSearchable }">
              <slot name="custom-select-label">
                <input v-model="search" v-if="isSearchable" type="text" :placeholder="$t('placeholder.search')" />
                <span v-else>{{ libraryName || $t('server.model.library') }}</span>
              </slot>
            </div>
            <div class="custom-select">
              <div
                v-for="(value, key) in filteredList"
                :key="key"
                class="custom-select-option"
                @click="changeSelected(value)"
                :class="{ active: selected == value, separator: $lodash.get(value, field) == '-' }"
              >
                <template v-if="$lodash.get(value, field) == '-'">
                  <hr />
                </template>
                <template v-else>
                  {{ $lodash.get(value, field) }}
                </template>
              </div>
            </div>
            <span @click="$emit('close', true)">
              <router-link @click="$emit('close', true)" class="add-new-link" :to="{ name: link }" target="_blank">{{
                linkName
              }}</router-link>
            </span>
          </div>
          <div class="column description">
            <p v-html="$lodash.get(selected, field_description)"></p>
            <edit-button v-if="!isLoading" :editOptions="['load']" @click="$emit('click:load', selected)">
              <template>
                <span class="text">{{ buttonName || $t('button.load') }}</span>
              </template>
            </edit-button>
            <loader v-else></loader>
          </div>
        </div>
        <div></div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import EditButton from '@/components/EditButton'
import Loader from '@/components/Loader'
export default {
  name: 'ModalLayout',
  components: {
    EditButton,
    Loader
  },
  props: {
    active: {
      type: Boolean,
      default: true
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    field: {
      type: String,
      default: 'type'
    },
    link: {
      type: String,
      default: ''
    },
    linkName: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    field_description: {
      type: String,
      default: 'default_description'
    },
    title: {
      type: String,
      default: ''
    },
    libraryName: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: undefined,
      search: ''
    }
  },
  mounted() {
    this.selected = this.items[0]
  },
  methods: {
    changeSelected(item) {
      if (this.$lodash.get(item, this.field) !== '-') {
        this.selected = item
      }
    }
  },
  computed: {
    filteredList() {
      let vm = this
      const filtered = this.items.filter(value => {
        return value[vm.field].toLowerCase().includes(vm.search.toLowerCase())
      })
      return filtered
    }
  },
  watch: {
    filteredList: {
      deep: true,
      handler: function(newVal) {
        this.selected = newVal[0]
      }
    }
  }
}
</script>

<style lang="scss">
.modal-layout {
  h1 {
    font-size: 150%;
    font-weight: bold;
    color: black;
    margin-bottom: 1rem;
  }
  .animation-content {
    width: 80vw;
    .modal-card {
      width: 80vw;
      .modal-card-body {
        .columns {
          .select-column {
            width: 40%;
            flex: none;
          }
          .custom-select-label {
            width: 100%;
            border: 1px solid #888;
            padding: 0.2rem 0.5rem;
            margin-bottom: 0.5rem;
            font-weight: bold;
            &.search {
              padding: 0;
              border: 0;
              input {
                display: block;
                width: 100%;
                font-size: 0.9rem;
                padding: 0.2rem 0.5rem;
                border: 1px solid #888;
              }
            }
          }
          .custom-select {
            border: 1px solid #888;
            overflow-y: auto;
            height: 55vh;
            .custom-select-option {
              width: 100%;
              padding: 0.2rem 0.5rem;
              cursor: pointer;
              &:hover {
                background-color: #f5f5f5;
              }
              &.active {
                background-color: #3273dc;
                color: white;
              }
              &.separator {
                margin: 0;
                hr {
                  margin: 0;
                  background-color: #888;
                  height: 1px;
                }
              }
            }
          }
          .add-new-link {
            display: block;
            width: 100%;
            text-align: right;
          }
          .description {
            position: relative;
            .edit-button {
              bottom: 0.75rem;
              right: 0.75rem;
              position: absolute;
            }
          }
        }
      }
    }
  }
}
</style>
